const AboutUs = () => {
    return (

        <div className="container-fluid bg-light overflow-hidden my-5 px-lg-0">
            <div className="container about px-lg-0">
                <div className="row g-0 mx-lg-0">
                    <div className="col-lg-6 ps-lg-0 wow fadeIn" data-wow-delay="0.1s">
                        <div className="position-relative h-100">
                            <br/>
                            <br/>
                            {/*<br/>*/}

                            <img className="position-absolute img-fluid w-100 h-90" src="img/about.png" alt=""></img>


                        </div>
                    </div>
                    <div className="col-lg-6 about-text py-6 wow fadeIn" data-wow-delay="0.5s">
                        <div className="p-lg-5 pe-lg-0">
                            <h4 className="text-primary">About Us</h4>
                            {/*<h1 className="mb-4">25+ Years Experience In Solar & Renewable Energy Industry</h1>*/}
                            <p class="text-xl-start">STEDAX Inc. is R&D Company in strength and reliability field.
                                Taking into consideration the importance of these characteristics mechanical structures,
                                big experience (42 patents) was created original theory (KTSM) and unique technology
                                (SARSYS) for solution numerous engineering tasks with wide area of applications.</p>
                            <h4 className="mb-4">OUR ADDED VALUE</h4>
                            <p class="text-xl-start">Many leading industries: aerospace, automotive, power,
                                construction, oil, gas etc. have a typical technological tasks and unique engineering
                                problems that required the custom solutions on the all stages of the structural life
                                from design to operation. The universal structure of SARSYS makes possible to resolve
                                all individual tasks in fatigue and durability area. We are very flexible and diplomatic
                                with our customers’ business relationships providing different kinds of products,
                                services on the most acceptable individually for each customer conditions.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default AboutUs;